import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { RootState } from '../../../app/store';
import MightyFitAPI from '../../../API/mightyFitAPI';

interface MightyFitState {
  mightyFitFilters: Array<Record<string, any>>;
  loaded: boolean;
  loading: boolean;
  loadError: Boolean;
  selectedFilters: Array<string>;
}

const initialState: MightyFitState = {
  mightyFitFilters: [],
  loaded: false,
  loading: false,
  loadError: false,
  selectedFilters: [],
}

export const loadMightyFit = createAsyncThunk(
  'mightyFitFilters/loadMightyFit',
  async () => {
    return await MightyFitAPI.getFilters();
  }
);

export const filterSlice = createSlice({
  name: "mightyFitFilters",
  initialState: initialState,
  reducers: {
    addMightyFitFilter: (state, action) => {
      state.selectedFilters.push(action.payload);
    },
    removeMightyFitFilter: (state, action) => {
      if (typeof action.payload === 'function') {
        state.selectedFilters = state.selectedFilters.filter(item => {
          const strItem = String(item);
          return !action.payload(strItem);
        });
      } else {
        state.selectedFilters = state.selectedFilters.filter(item => String(item) !== String(action.payload));
      }
    },
    clearMightyFitFilter: (state) => {
      state.selectedFilters = state.selectedFilters.filter(
        (filter) => typeof filter === 'string' && filter.startsWith('search_text=')
      );
    },
  },
  extraReducers: builder => {
    builder.addCase(loadMightyFit.pending, (state) => {
      return {
        ...state,
        loading: true
      }
    });
    builder.addCase(loadMightyFit.fulfilled, (state, action) => {
      const data = action.payload;
      const filteredData = data.filter_data;
      return {
        ...state,
        mightyFitFilters: filteredData,
        loading: false,
        loaded: true
      }
    });
    builder.addCase(loadMightyFit.rejected, (state) => {
      return {
        ...state,
        loading: false,
        loadError: true
      }
    });
  }
});

export const { addMightyFitFilter, clearMightyFitFilter, removeMightyFitFilter, } = filterSlice.actions;
export const selectMightyFitFilters = (state: RootState) => state.mightyFitFilters.mightyFitFilters;
export const selectSelectedFilters = (state: RootState) => state.mightyFitFilters.selectedFilters;
export const selectMightyFitFiltersLoaded = (state: RootState) => state.mightyFitFilters.loaded;
export const selectMightyFitFiltersLoadError = (state: RootState) => state.mightyFitFilters.loadError;
export const selectMightyFitFiltersLoading = (state: RootState) => state.mightyFitFilters.loading;
export default filterSlice.reducer;